import script from "./ScheduledEmailsBatchDeleteConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduledEmailsBatchDeleteConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ScheduledEmailsBatchDeleteConfirmDialog.vue?vue&type=style&index=0&id=353129cd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353129cd"]])

export default __exports__